import WeaponItemGraphics from "../entity/WeaponItem"

export default ({ renderer, /* simulator */ }) => {
	return {
		create: ({ data }) => {
			const entity = new WeaponItemGraphics(data, renderer)

			renderer.entities.set(entity.id, entity)
			renderer.middleground.addChild(entity)

			//simulator.createEntity(data)

			return entity
		},
		delete: ({ id, /* entity */ }) => {
			renderer.deleteEntity(id)
			//simulator.deleteEntity(id)
		},
		watch: {
		}
	}
}
